<template>
  <message-dialog
    :open="showDialog"
    closable
    data-testid="UpgradeNoticeModal"
    @close="$emit('closeUpgradeNotice')"
  >
    <template #title>Izmanto Somas<br />pilnās priekšrocības</template>
    <template #text>
      Papildini savu Somu un izbaudi visu mācību
      <br />
      saturu bez ierobežojumiem.
    </template>

    <template #actions>
      <v-btn flat color="yellowActive" rounded="pill" @click="redirectToUpgrade">Abonēt</v-btn>
    </template>
  </message-dialog>
</template>

<script lang="ts">
export default {
  props: {
    showDialog: {
      required: true,
      type: Boolean,
    },
  },

  emits: ["closeUpgradeNotice"],

  setup() {
    const config = useRuntimeConfig()

    return { config }
  },

  methods: {
    redirectToUpgrade() {
      navigateTo("/profile/abonements")
    },
  },
}
</script>
